/// <amd-module name="Repos/Views/Settings/Branches/Components/AdditionalDataTable/AdditionalDataTable" />
import React = require("react");
import { refToBranchOrTagName } from "Repos/Common/Util/Ref";
import * as Resources from "Repos/Views/Settings/Branches/Resources";
import { ISettingsViewService, SettingsQueryStringParams } from "Repos/Views/Settings/Common/Services/SettingsViewService";
import { css, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ConditionalChildren } from "VSSUI/ConditionalChildren";
import { Icon } from "VSSUI/Icon";
import { ITableColumn, ITableRowDetails, renderColumns, SimpleTableCell, Table, TableColumnLayout } from "VSSUI/Table";
import { SimpleGitRef } from "../../Data/SimpleGitRef";
import { ShareFocusRow } from "../SharedFocusRow/ShareFocusRow";
import { IAdditionalDataTableProps } from "./AdditionalDataTable.Props";

export class AdditionalDataTable extends VssComponent<IAdditionalDataTableProps, {}> {
    private columns: ITableColumn<{}>[];

    public constructor(props: IAdditionalDataTableProps, context: IVssComponentContext) {
        super(props, context);

        this.columns = this.getColumns();
    }

    public render = (): JSX.Element => {
        const settingsSvc = this.context.pageContext.getService<ISettingsViewService>("SettingsViewService");
        const urlParams = settingsSvc.getUrlParameters();
        const tabId = urlParams[SettingsQueryStringParams.tabId];
        const repositoryId = urlParams[SettingsQueryStringParams.repositoryId];

        return (
            <ConditionalChildren inverse={true} renderChildren={this.props.hidden}>
                <Table<SimpleGitRef>
                    columns={this.columns}
                    itemProvider={this.props.data}
                    role="table"
                    showHeader={false}
                    selection={this.props.selection}
                    className={"setting-branches-addtional-data"}
                    renderRow={(index: number, item: SimpleGitRef, details: ITableRowDetails<SimpleGitRef>) => {
                        return (
                            <ShareFocusRow
                                index={index}
                                details={details}
                                focusZoneId={this.props.focusZoneContext.focuszoneId}
                                linkProps={{
                                    href: settingsSvc.getUrl(repositoryId, item.ref, tabId),
                                    onClick: event => this.onClickLink(event, item)
                                }}
                            >
                                {renderColumns(index, this.getColumns(), item, details)}
                            </ShareFocusRow>
                        );
                    }}
                />
            </ConditionalChildren>
        );
    };

    private getColumns = (): ITableColumn<{}>[] => {
        return [
            {
                columnLayout: TableColumnLayout.singleLinePrefix,
                id: "displayText",
                name: Resources.Name,
                readonly: true,
                renderCell: (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<SimpleGitRef>, tableItem: SimpleGitRef) => {
                    return (
                        <SimpleTableCell columnIndex={columnIndex} key={tableItem.ref} tableColumn={tableColumn} className="bolt-tree-cell">
                            <span
                                aria-hidden="true"
                                className="bolt-tree-expand-button font-size cursor-pointer invisible flex-noshrink fabric-icon ms-Icon--ChevronRightMed small"
                                role="presentation"
                            ></span>
                            {tableItem.iconProps && <Icon {...tableItem.iconProps} className={css("icon-margin", tableItem.iconProps.className)} />}
                            <span className="text-ellipsis flex-self-center">{tableItem.displayText || refToBranchOrTagName(tableItem.ref)}</span>
                        </SimpleTableCell>
                    );
                },
                width: -100
            }
        ];
    };

    private onClickLink = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent> | React.KeyboardEvent<HTMLAnchorElement>, data: SimpleGitRef) => {
        if (!event.shiftKey && !event.ctrlKey) {
            this.props.onRowActivate(data);
            event.preventDefault();
        }
    };
}
